import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';

export interface User { id: number; username: string; role: string; }

@Injectable({ providedIn: 'root' })
export class AuthService {
    currentUser: User | null = null;

    constructor(private http: HttpClient, private router: Router) {
        const stored = localStorage.getItem('current_user');
        if (stored) this.currentUser = JSON.parse(stored);
    }

    login(username: string, password: string) {
        return this.http.post<{ access_token: string; user: User }>('/api/auth/login', { username, password }).pipe(
            tap(res => {
                localStorage.setItem('access_token', res.access_token);
                localStorage.setItem('current_user', JSON.stringify(res.user));
                this.currentUser = res.user;
                // Redirection après mise à jour de currentUser
                this.router.navigate([res.user.role === 'admin' ? '/home' : '/vehicles']);
            })
        );
    }

    changePassword(current_password: string, new_password: string) {
        return this.http.put<{ message: string }>('/api/auth/change-password', { current_password, new_password });
    }

    getAllUsers() {
        return this.http.get<User[]>('/api/auth/users');
    }

    adminChangePassword(userId: number, new_password: string) {
        return this.http.put<{ message: string }>(`/api/auth/users/${userId}/password`, { new_password });
    }

    logout() {
        this.http.post('/api/auth/logout', {}).subscribe({ error: () => { } });
        localStorage.removeItem('access_token');
        localStorage.removeItem('current_user');
        this.currentUser = null;
        this.router.navigate(['/login']);
    }

    isLoggedIn(): boolean { return !!localStorage.getItem('access_token'); }
    isAdmin(): boolean { return this.currentUser?.role === 'admin'; }
}
